export default function getDocumentElement(element) {
  return element.ownerDocument.documentElement;
}